namespace Matrix.Data {
    export interface SourceForm {
        SourceCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Group: Serenity.StringEditor;
        Category: Serenity.StringEditor;
    }

    export class SourceForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Source';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SourceForm.init)  {
                SourceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(SourceForm, [
                    'SourceCode', w0,
                    'Name', w0,
                    'Group', w0,
                    'Category', w0
                ]);
            }
        }
    }
}
